export default {
  endpoints: {
    stitchBackend: "http://localhost:8080",
  },
  debug: true,
};
